import { SelectorBase } from '../../Config/SelectorBase';
import { IActivityThemeModel } from './ActivityTheme';
import Activity from '../Activity/Activity';
import { UserSelector } from '../User/User.Selector';
import { count } from 'console';
// DLA TEST
import ActivityTheme from 'src/Entities/ActivityTheme/ActivityTheme';
import ActivityCategory from '../ActivityCategory/ActivityCategory';

/* Selector represents the data
 * that needs to be displayed no update or delete should here
 * All of the updates and delete (data changes) should
 * be done via action in the reducer
 */
export class ActivityThemeSelector extends SelectorBase {
  public static getThemes(): IActivityThemeModel[] {
    const session = super.getDataSource();
    const activitythemes = session.ActivityTheme.all().toModelArray();
    return activitythemes;
  }
  public static getThemeById(id: number): IActivityThemeModel {
    const session = super.getDataSource();
    return session.ActivityTheme.withId(id.toString());
  }

  public static getRelevantThemeCounts(): number[] {
    const session = super.getDataSource();
    const topics = UserSelector.getUserInterests();
    const themes = session.ActivityTheme.all().toModelArray();

    return themes.map((theme): number => {
      // antallet af kurser i temaet
      // 30 --> MAp temaer som har relevante topics
      // 5-- > antaller af alle aktiviter i temaet
      if (!UserSelector.isShowOnlyUserIntrests() || topics === undefined) {
        return theme.NumberOfCoursesInTheme;
      }

      const categories = session.ActivityCategory.all()
        .filter(
          (category: ActivityCategory) =>
            topics.indexOf(category.categoryId.toString()) > -1
        )
        .filter(
          (category: ActivityCategory) => category.themeId === theme.themeId
        )
        .toModelArray();

      return categories
        .map(category => {
          return session.Activity.all()
            .filter((a: Activity) => a.categoryId === category.categoryId)
            .count();
        })
        .reduce((sum: number, c: number) => sum + c, 0);
    });
  }
}



// WEBPACK FOOTER //
// ./src/Entities/ActivityTheme/ActivityTheme.Selector.ts